<template>
  <el-container class="home-container">
    <!-- 页面主体区域 -->
    <el-container>
      <!-- 侧边栏 -->
      <el-aside :width="isCollapse?'64px':'200px'">
        <div class="top-container">
          <div class="toggle-button" @click="toggleCollapse">
            <div class="img" v-if="!isCollapse">
              <img src="@/assets/img/rifeng.jpg" alt />
              Rifeng Guard
            </div>
            <div class="collapseImg" v-else>
              <img src="@/assets/img/rifeng.jpg" alt />
            </div>
            <div class="tailbtn"></div>
          </div>
          <!-- 侧边栏菜单区域 -->
          <sidebar ref="sideBar"></sidebar>
        </div>

        <div class="userInfo" @mouseenter="showUserOption" @mouseleave="hideUserOption">
          <div :class="showOPtionsItem?'change':'change1'" v-if="!isCollapse">
            <div v-if="showOPtionsItem">
              <div :class="showOPtionsItem?'showItem':'hidItem'" @click="changePassword">
                <i class="el-icon-setting"></i>Change Password
              </div>
              <div :class="showOPtionsItem?'showItem':'hidItem'" @click="open">
                <i class="el-icon-circle-close" slot="reference"></i>Logout
              </div>
            </div>
          </div>

          <div :class="showOPtionsItem?'activeImgContainer':'imgContainer'">
            <el-avatar :size="50" v-if="avatarUrl!= null" :src="avatarUrl"></el-avatar>
            <el-avatar
              :size="50"
              v-else
              src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
            ></el-avatar>
            <span v-if="!isCollapse" style="color:#fff;margin-left:5px">{{userName}}</span>
          </div>
        </div>
      </el-aside>

      <div
        class="collapseBox"
        :class="showOPtionsItem?'change2':'change3'"
        v-if="isCollapse"
        @mouseover="showUserOption"
        @mouseleave="hideUserOption"
      >
        <div :class="showOPtionsItem?'showItem':'hidItem'" @click="changePassword">
          <i class="el-icon-setting text"></i>Change Password
        </div>
        <div :class="showOPtionsItem?'showItem':'hidItem'" @click="open">
          <i class="el-icon-circle-close text" slot="reference"></i>Logout
        </div>
      </div>

      <!-- 右侧主体内容 -->

      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
    <el-dialog title="Change the password" center :visible.sync="upDatePasswordVisible">
      <el-form
        :model="passwordForm"
        status-icon
        :rules="rules"
        ref="passwordFormRef"
        label-width="200px"
      >
        <el-form-item label="Old password" prop="oldPassword">
          <el-input type="password" v-model="passwordForm.oldPassword"></el-input>
        </el-form-item>
        <el-form-item label="New password" prop="newPassword">
          <el-input type="password" v-model="passwordForm.newPassword"></el-input>
        </el-form-item>
        <el-form-item label="Confirm the new password" prop="newPassword1">
          <el-input type="password" v-model="passwordForm.newPassword1"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm('passwordFormRef')">Cancel</el-button>
          <el-button type="primary" @click="submitForm()">Submit</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-container>
</template>

<script>
import Sidebar from '@/components/sidebar/Sidebar'
import db from '@/services/localstorage'
export default {
  components: {
    Sidebar,
  },
  data() {
    var oldPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the old password'))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the new password'))
      } else {
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter new password again'))
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error("The new passwords don't match!"))
      } else {
        callback()
      }
    }
    return {
      userName: '',
      avatarUrl: '',
      // 左侧菜单数据
      menuList: [],

      // 菜单栏是否隐藏
      isCollapse: false,

      // 被激活的链接地址
      activePath: '',
      showOPtionsItem: false,
      // 鼠标是否移入移出
      mouseenter: false,
      // 修改密码弹窗
      upDatePasswordVisible: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        newPassword1: '',
      },
      rules: {
        oldPassword: [{ validator: oldPassword, trigger: 'blur' }],
        newPassword: [{ validator: validatePass, trigger: 'blur' }],
        newPassword1: [{ validator: validatePass2, trigger: 'blur' }],
      },
    }
  },
  methods: {
    // 提交表单
    submitForm() {
      this.$refs.passwordFormRef.validate((valid) => {
        if (!valid) return
        this.passwordForm.loginAccount = db.get('user').loginAccount
        console.log(this.passwordForm)
        this.$post('auth/updateMyPwd', this.passwordForm).then(
          ({ data: res }) => {
            if (!res.ok) {
              return this.$message.error('old password is error')
            }
            this.$message.success('updated successfully')
            this.upDatePasswordVisible = false
          }
        )
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.upDatePasswordVisible = false
    },
    showUserOption() {
      console.log('show')
      this.showOPtionsItem = true
    },
    hideUserOption() {
      console.log('hide')
      this.showOPtionsItem = false
    },
    // 修改密码
    changePassword() {
      this.upDatePasswordVisible = true
    },
    open() {
      this.$confirm('logout？', 'logout', {
        distinguishCancelAndClose: true,
        confirmButtonText: 'logout',
        cancelButtonText: 'cancel',
      })
        .then(() => {
          this.logout()
          this.$message({
            type: 'success',
            message: 'logout successfully',
          })
        })
        .catch(() => {})
    },
    //  退出
    logout() {
      window.sessionStorage.clear()
      db.clear()
      // 清空后重新刷新页面，没有token自动跳转login
      location.reload()
    },

    // 点击按钮切换菜单的折叠与展开
    toggleCollapse() {
      this.$refs.sideBar.isCollapse = !this.$refs.sideBar.isCollapse
      this.isCollapse = !this.isCollapse
    },
  },
  created() {
    this.userName = db.get('user').userName
    this.avatarUrl = db.get('user').avatarUrl
    this.menuList = db.get('USER_ROUTER')[0].children
  },
}
</script>

<style lang='less' scoped>
@import '@/assets/css/base.less';

.home-container {
  height: 100%;
}
.el-header {
  background-color: #373d41;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: #fff;
  font-size: 20px;
  > div {
    display: flex;
    align-items: center;
    span {
      margin-left: 15px;
    }
  }
}
.el-container {
  position: relative;
}
.el-aside {
  background-color: #3c5179;
  display: flex;
  flex-direction: column;
  overflow: visible;
  &::-webkit-scrollbar {
    width: 0px; //滚动条的宽度
    height: 0px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #8899a7; //滚动条的颜色
    border-radius: 3px; //滚动条的边框倒角
  }
  .top-container {
    flex: 1;
    // overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 0px; //滚动条的宽度
      height: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #8899a7; //滚动条的颜色
      border-radius: 3px; //滚动条的边框倒角
    }
    .el-menu {
      border-right: none;
      overflow-y: scroll;
      overflow-x: hidden;

      &::-webkit-scrollbar {
        width: 0px; //滚动条的宽度
        height: 6px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #8899a7; //滚动条的颜色

        border-radius: 3px; //滚动条的边框倒角
      }
    }
  }

  .userInfo {
    width: 100%;
    height: 0.3646rem;
    position: relative;
    .change {
      width: 1.0417rem;
      height: 80px;
      background: #9aa5ba;
      position: absolute;
      z-index: 9;
    }

    .imgContainer {
      position: absolute;
      z-index: 999;
      height: 100%;
      width: 100%;
      display: flex;
      background: #3c5179;
      justify-content: flex-start;
      align-items: center;
      .el-avatar {
        width: 100%;
        margin: 0 5px 0 5px;
      }
    }
    .activeImgContainer {
      position: absolute;
      z-index: 999;
      height: 100%;
      width: 100%;
      display: flex;
      background: #9aa5ba;
      justify-content: flex-start;
      align-items: center;
      .el-avatar {
        width: 100%;
        margin: 0 5px 0 5px;
      }
    }
    .showItem {
      cursor: pointer;
      box-sizing: border-box;
      border-top: 1px solid #fff;
      background: #5c677c;
      height: 40px;
      display: flex;
      width: 100%;
      color: #fff;
      align-items: center;
      i {
        margin: 0 10px 0 10px;
      }
    }
    .hideItem {
      display: none;
    }
  }
}
// -------------------------------------------------------------------------

.collapseBox {
  height: 70px;
  width: 1.0417rem;
  background: #3c5179;
  position: absolute;
  bottom: 0;
  z-index: 9;
  transform: translate(-66px, 0);
  display: none;
  div {
    flex: 1;
    border-top: 1px solid #ccc;
    color: #fff;
    display: flex;
    align-items: center;
    i {
      margin: 0 10px;
    }
  }
}
.userInfo .change {
  animation: myMou 0.5s;
  animation-fill-mode: forwards;
}
.userInfo .change1 {
  animation: myMou1 0.5s;
  animation-fill-mode: forwards;
}

.change2 {
  animation: myMou2 0.5s;
  animation-fill-mode: forwards;
  display: flex;
  flex-direction: column;
}

.change3 {
  animation: myMou3 0.5s;
  animation-fill-mode: forwards;
}

@keyframes myMou {
  0% {
    top: 0;
  }
  100% {
    top: -80px;
  }
}

@keyframes myMou1 {
  0% {
    top: -80px;
  }
  100% {
    top: 0;
  }
}

@keyframes myMou2 {
  0% {
    left: -135px;
  }
  100% {
    left: 129px;
  }
}

@keyframes myMou3 {
  0% {
    left: 129px;
  }
  100% {
    left: -135px;
  }
}
// -----------------------------------------------------

.el-main {
  background-color: #fff;
}
.iconfont {
  margin-right: 10px;
}
.toggle-button {
  background-color: #3c5179;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
  position: relative;
  height: 70px;
  padding: 10px 0;

  .img {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: bold;
    z-index: 99;
    img {
      width: 0.2604rem;
      height: 0.2604rem;
      border-radius: 5px;
      margin: 10px 13px 10px 17px;
    }
  }
  .collapseImg {
    img {
      width: 0.2083rem;
      height: 40px;
      border-radius: 10px;
      margin: 10px;
    }
  }
}

.is-active {
  background: #f5f8fd !important;
}

/deep/.el-tooltip__popper {
  width: 100% !important;
}

.content-item {
  background: red;
}
</style>
